module.exports = "https://static.energy5.com/_next/static/images/googlePlay-7af4ea3d95bf4d8663608c7305f07e4e.png";